import { useEffect, useRef, useState } from 'react'
import { Tooltip } from 'primereact/tooltip'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// local imports
import { IFilteredParkAreaList } from 'types/ParkAreaType'
import {
  ReservationButton,
  ParkAreaName,
  ParkAreaLocation,
  WorkingHours,
  StyledCard,
  CardHeaderOverlay,
  ParkAreaCapacity,
  Summary,
} from './styled'

interface ComponentProps {
  parkArea: IFilteredParkAreaList
  locationName: string
  openModal: (area: IFilteredParkAreaList) => void
}

export default function ParkAreaCard({ parkArea, locationName, openModal }: ComponentProps) {
  const { t } = useTranslation()
  const sumRef = useRef<HTMLSpanElement>(null)
  const [hasTooltip, setHasTooltip] = useState(false)

  /* ######### Park Area Data Destructuring ######### */
  const {
    name,
    startHourStr,
    endHourStr,
    reservationCapacity: maxCapacity,
    reservationCount,
    explanation,
    // PlateExplanation,
  } = parkArea || {}

  /* Variables - functions */
  const reservationCapacity = `${reservationCount}/${maxCapacity}`
  const isFullCapacity = reservationCount === maxCapacity
  const openSearchModal = () => openModal(parkArea)

  useEffect(() => {
    const calculateLines = () => {
      const lineHeight = 14
      const lines = (sumRef.current?.offsetHeight || 0) / lineHeight
      return lines >= 5
    }
    setHasTooltip(() => calculateLines())
  }, [])

  return (
    <StyledCard>
      <CardHeaderOverlay />
      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <ParkAreaName>{`${name}`}</ParkAreaName>
          <ParkAreaLocation>{locationName}</ParkAreaLocation>
          <ParkAreaCapacity>
            <i className="pi pi-users"></i>
            <span>{reservationCapacity}</span>
          </ParkAreaCapacity>

          {explanation && (
            <>
              {hasTooltip && <StyledTooltip target=".summary" />}
              <Summary
                data-pr-tooltip={hasTooltip ? explanation : null}
                data-pr-position="bottom"
                ref={sumRef}
                className="summary">
                {explanation}
              </Summary>
            </>
          )}
        </div>
        <WorkingHours>
          <span className="wh-title">{t('most-used-words.working-hours')}: </span>
          <span>
            {startHourStr} - {endHourStr}
          </span>
        </WorkingHours>

        <ReservationButton disabled={isFullCapacity} onClick={openSearchModal}>
          {t('buttons.book-reservation')}
        </ReservationButton>
      </div>
    </StyledCard>
  )
}

const StyledTooltip = styled(Tooltip)`
  height: auto;
  max-width: 280px;
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
`
